import React from 'react';

import { TYPE_CONVERSION, TYPE_POSTBACK } from 'scenes/Integrations/constants';

import IntegrationConversionDetails from './IntegrationConversionDetails';
import IntegrationPostbackDetails from './IntegrationPostbackDetails';

const IntegrationDetails = ({ type, ...props }) => {
  if (Number(type) === TYPE_CONVERSION) {
    return <IntegrationConversionDetails {...props} />;
  }

  if (Number(type) === TYPE_POSTBACK) {
    return <IntegrationPostbackDetails {...props} />;
  }
};

export default IntegrationDetails;
